import React, { Component } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { Field } from 'redux-form';
import { Row, Col, Input } from 'react-bootstrap';
import Selection from '../Common/selection';
import Spinner from '../Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'

let renderInputField = props => {
    const inputClass = classNames({ 'parsley-error': props.meta.touched && props.meta.error }, 'form-control')
    return (
        <div>
            {props.meta.touched && props.meta.error && <span className="parsley-error-message">{props.meta.error}</span>}
            <Input {...props.input} className={inputClass} type="text"/>
        </div>
    )
}

class ReceiveModal extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    componentDidMount() {
        this.props.fetchPurchaseOrders();
    }

    handleFormSubmit(formProps) {
        this.setPurchaseOrder(formProps.PurchaseOrder_id.value);
    }

    setPurchaseOrder(id) {
        const { resetCurrentPurchaseOrder, purchaseOrders, selectPurchaseOrder } = this.props
        resetCurrentPurchaseOrder();
        if (id) {
            const index = _.findIndex(purchaseOrders, { 'PurchaseOrder_id': id });
            selectPurchaseOrder(purchaseOrders[index]);
            // this.context.router.push('/purchaseReturn/'+purchaseOrders[index].PurchaseOrder_id);
        }
        this.context.router.push('/inventories/receive/new');

    }

    renderPurchaseOrders() {
        if (this.props.isLoading) return <Col sm={ 12 } className="marginTopStyle"><Spinner/></Col> // If group is loading, show a spinner.
        else {
            let purchaseOrderOptions = this.getPurchaseOrderOptions();
            return (
                <Col sm={ 12 } className="marginTopStyle">
                    <label className="centerStyle" ><Translate value="select_a_purchase_order" /></label>
                    <Field name="PurchaseOrder_id" component={Selection} options={purchaseOrderOptions}/>
                </Col>
            )
        }
    }

    getPurchaseOrderOptions() {
        var purchaseOrderOptions = [];
        this.props.purchaseOrders.map(purchaseOrder => {
            purchaseOrderOptions.push({ value: purchaseOrder.PurchaseOrder_id, label: purchaseOrder.PONum })
        });
        return purchaseOrderOptions;
    }

    // Once User choose a Order, show him some detail
    renderOrderDetail(id) {
        const { purchaseOrders } = this.props;
        const index = _.findIndex(purchaseOrders, { 'PurchaseOrder_id': id });
        if (index > -1) {
            const vendorName = purchaseOrders[index].Vendor_id.Name;
            const updateTime = purchaseOrders[index].UpdateTime;
            const PONum = purchaseOrders[index].PONum;
            return (
                <div>
                    <br/>
                    <Row><Col sm={ 12 }>
                        <Translate value="purchase_order_no" />: {PONum}
                    </Col></Row>
                    <Row><Col sm={ 12 }>
                        <Translate value="vendor_name" />: {vendorName}
                    </Col></Row>
                    <Row><Col sm={ 12 }>
                        <Translate value="update_time" />: {updateTime}
                    </Col></Row>
                </div>
            )
        }
    }

    render() {
        const { handleSubmit, closeC, submitting, pristine, purchaseOrderValue } = this.props;
        return (
            <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                <Row>
                    {this.renderPurchaseOrders() }
                </Row>
                {purchaseOrderValue && this.renderOrderDetail(purchaseOrderValue.value) }
                <br/>
                <br/>
                <Row>
                    <button action="submit" className="btn btn-primary col-sm-11 buttonStyle" disabled={ submitting } ><Translate value="select_a_purchase_order" /></button>
                </Row>
                <br/>
                <Row>
                    <button className="btn btn-danger col-sm-11 buttonStyle" onClick={(event) => { event.preventDefault(); closeC(); } } ><Translate value="cancel" /></button>
                </Row>
            </form>
        )
    }
}

export default ReceiveModal



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/receiveModal.jsx